import React from "react";
import { Link } from "react-router-dom";
import { Twitter, Linkedin, Github } from "lucide-react";

const LOGO = "/leadmato-logo.png";

const COLS = [
  {
    title: "Product",
    links: [
      { label: "Features", to: "/features" },
      { label: "Pricing", to: "/pricing" },
      { label: "Roadmap", to: "/roadmap" },
      { label: "Demo", to: "/demo" },
      { label: "Changelog", to: "/roadmap" },
    ],
  },
  {
    title: "Resources",
    links: [
      { label: "Blog", to: "/blog" },
      { label: "API Docs", to: "/developers" },
      { label: "Help Center", to: "/contact" },
    ],
  },
  {
    title: "Legal",
    links: [
      { label: "Privacy Policy", to: "/privacy-policy" },
      { label: "Terms of Service", to: "/terms-of-service" },
      { label: "Refund Policy", to: "/refund-policy" },
      { label: "Cookie Policy", to: "/cookie-policy" },
    ],
  },
  {
    title: "Company",
    links: [
      { label: "About", to: "/about" },
      { label: "Contact", to: "/contact" },
      { label: "support@aifreedomclub.com", href: "mailto:support@aifreedomclub.com" },
    ],
  },
];

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="marketing-footer"
      className="bg-[#0A0A0A] text-white/80"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 md:px-10 py-12 sm:py-14 md:py-20">
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-8 sm:gap-10">
          <div className="col-span-2 sm:col-span-3 lg:col-span-2 flex flex-col gap-4 sm:gap-5">
            <img
              src={LOGO}
              alt="Leadmato"
              className="h-8 sm:h-9 md:h-10 w-auto max-w-[170px] object-contain select-none"
              draggable="false"
            />
            <p className="text-sm text-white/60 max-w-md leading-relaxed">
              Type a query. Get real customers. Leadmato finds the exact moments future customers
              describe their problems online — and ranks them by buying intent.
            </p>
            <div className="flex items-center gap-3 mt-1 sm:mt-2">
              <a href="#" aria-label="Twitter" className="w-9 h-9 rounded-lg bg-white/5 hover:bg-white/10 flex items-center justify-center transition-colors">
                <Twitter className="w-4 h-4" />
              </a>
              <a href="#" aria-label="LinkedIn" className="w-9 h-9 rounded-lg bg-white/5 hover:bg-white/10 flex items-center justify-center transition-colors">
                <Linkedin className="w-4 h-4" />
              </a>
              <a href="#" aria-label="GitHub" className="w-9 h-9 rounded-lg bg-white/5 hover:bg-white/10 flex items-center justify-center transition-colors">
                <Github className="w-4 h-4" />
              </a>
            </div>
          </div>

          {COLS.map((col) => (
            <div key={col.title} className="col-span-1 flex flex-col gap-3">
              <h4 className="text-xs font-mono uppercase tracking-widest text-white/40">{col.title}</h4>
              <ul className="flex flex-col gap-2">
                {col.links.map((l) => (
                  <li key={l.label}>
                    {l.to ? (
                      <Link
                        to={l.to}
                        data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                        className="text-sm text-white/70 hover:text-white transition-colors break-words"
                      >
                        {l.label}
                      </Link>
                    ) : (
                      <a
                        href={l.href}
                        className="text-sm text-white/70 hover:text-white transition-colors break-words"
                      >
                        {l.label}
                      </a>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 sm:mt-12 md:mt-14 pt-6 sm:pt-8 border-t border-white/10 text-center">
          <div className="text-xs sm:text-sm text-white/60">
            © {year} Win Massive Impact Pvt. Ltd. · All rights reserved.
          </div>
        </div>
      </div>
    </footer>
  );
}
